import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'
import './index.css'
import App from './App.tsx'
import IdvFlow from './IdvFlow.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <>
            <h3>Demo: verify identity to ACME Corp</h3>
            <div>If all the security checks pass, your information will be shown here and not stored</div>
            <App />
          </>
        } />
        <Route path="/idv/:ref" element={<IdvFlow />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
